import dayjs from 'dayjs'
import doneCreate from '../../../assets/images/done-create.svg'
import errorAlert from '../../../assets/images/error-alert.svg'
import { DocumentDetailModel } from '../../../models/documentDetail'
import { getPaymentDetailAmount, getPaymentDetailValue } from '../helper'
import NumberFormat from 'react-number-format'
import { WatDatePicker } from '../../../component/datePicker'
import { ChangeEvent } from 'react'
import { IPaymentDetailProps } from './ipaymentDetailProps.interface'
import { Bank } from '../../../component/entryForm/bank'
import { PayInBank } from '../../../component/entryForm/bankAccount'
import { PAYMENTMODE } from '../../../constants'

export const CompanyCheque: React.VFC<IPaymentDetailProps> = ({
  paymentDetail,
  handleEnterKey,
  formErrors,
  paymentMethod,
  onChangeAmountDetail,
  handleWatDatePickerChangeAmountDetail,
  handlePayInDateChangeAmountDetail,
  branchCode
}) => {
  const handleChequeDate = (christDate: any, buddhistDate: any) => {
    handleWatDatePickerChangeAmountDetail(christDate, buddhistDate, paymentMethod.id)
  }
  const handlePayInDateChange = (christDate: any, buddhistDate: any) => {
    handlePayInDateChangeAmountDetail(christDate, buddhistDate, paymentMethod.id)
  }
  return (
    <div className="required">
      <span className="amount-text">เลขที่เช็ค</span>
      <input
        className={`amount-input ${formErrors.cheque_Number_FWDCKC && 'error-border-validate'}`}
        type="text"
        name="cheque_Number"
        autoComplete="off"
        onKeyPress={e => handleEnterKey(e)}
        onChange={e => onChangeAmountDetail(e, paymentMethod.name)}
        value={getPaymentDetailValue(paymentDetail, paymentMethod.name, 'cheque_Number')}
      />
      {formErrors.cheque_Number_FWDCKC && (
        <div className="error-text-validate">
          <img src={errorAlert} alt="ErrorAlert" />
          กรุณากรอกข้อมูล
        </div>
      )}

      <span className="amount-text">ลงวันที่</span>
      <WatDatePicker
        className={`amount-input ${formErrors.cheque_Date_FWDCKC && 'error-border-validate'}`}
        name="cheque_Date"
        onChange={handleChequeDate}
        dateFormat={'yyyy-MM-dd'}
        displayFormat={'DD/MM/YYYY'}
        clearable={false}
        minDate={dayjs().add(-2, 'year')}
        maxDate={dayjs().add(5, 'year')}
        disabled={false}
        readOnly={false}
        yearBoundary={99}
        inputStyle={formErrors.cheque_Date_FWDCKC ? { borderColor: '#b30909' } : null}
        value={getPaymentDetailValue(paymentDetail, paymentMethod.name, 'cheque_Date')}
      />
      {formErrors.cheque_Date_FWDCKC && (
        <div className="error-text-validate">
          <img src={errorAlert} alt="ErrorAlert" />
          {typeof formErrors.cheque_Date_FWDCKC === 'string'
            ? formErrors.cheque_Date_FWDCKC
            : 'กรุณากรอกข้อมูล'}
        </div>
      )}

      <span className="amount-text not-required">วันที่ฝาก</span>
      <WatDatePicker
        className={`amount-input ${formErrors.PayInDate_FWDCKC && 'error-border-validate'}`}
        name="payInDate"
        onChange={handlePayInDateChange}
        dateFormat={'yyyy-MM-dd'}
        displayFormat={'DD/MM/YYYY'}
        clearable={false}
        minDate={dayjs().add(-2, 'year')}
        maxDate={dayjs().add(5, 'year')}
        disabled={false}
        readOnly={false}
        yearBoundary={99}
        inputStyle={formErrors.PayInDate_FWDCKC ? { borderColor: '#b30909' } : null}
        value={getPaymentDetailValue(paymentDetail, paymentMethod.name, 'payInDate')}
      />
      {formErrors.PayInDate_FWDCKC && (
        <div className="error-text-validate">
          <img src={errorAlert} alt="ErrorAlert" />
          กรุณากรอกข้อมูล
        </div>
      )}
      <span className="amount-text">จำนวนเงิน(บาท)</span>
      <NumberFormat
        onKeyPress={(e: any) => handleEnterKey(e)}
        allowNegative={false}
        thousandSeparator={true}
        prefix=""
        decimalScale={2}
        name="paymentAmount"
        className={`amount-input ${formErrors.paymentAmount_FWDCKC && 'error-border-validate'}`}
        inputMode="decimal"
        autoComplete="off"
        onChange={(e: ChangeEvent<HTMLInputElement>) => onChangeAmountDetail(e, paymentMethod.name)}
        value={getPaymentDetailAmount(paymentDetail, paymentMethod.name)}
      />
      {formErrors.paymentAmount_FWDCKC && (
        <div className="error-text-validate">
          <img src={errorAlert} alt="ErrorAlert" />
          กรุณากรอกข้อมูล
        </div>
      )}
    </div>
  )
}
